import { E_ROUTE_ACCOUNT } from './route.types';
export default [
    {
        name: E_ROUTE_ACCOUNT.ACCOUNTS,
        path: '/accounts',
        component: () => import(/* webpackChunkName: "account" */ '../../views/account-next/Accounts/Accounts.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.account.account',
                    active: true,
                }
            ],
            permission: 'Account',
        },
    },
    {
        name: E_ROUTE_ACCOUNT.ACCOUNT_NEXT,
        path: '/accounts/:id',
        component: () => import(/* webpackChunkName: "account" */ '../../views/account-next/Account/Account.vue'),
        props: true,
        children: [
            {
                name: E_ROUTE_ACCOUNT.ACCOUNT_TENANT,
                path: 'tenant/:tenant_id',
                component: () => import(/* webpackChunkName: "AccountTenant" */ '../../views/account-next/AccountTenant/AccountTenant.vue'),
                redirect: {
                    name: E_ROUTE_ACCOUNT.ACCOUNT_DEFAULT,
                },
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.account.account',
                            to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                        },
                        {
                            text: '租户信息',
                            active: true,
                        }
                    ],
                    permission: 'AccountsDetail',
                },
                children: [
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_DEFAULT,
                        path: 'default',
                        component: () => import(/* webpackChunkName: "account" */ '../../views/account-next/AccountDefault/AccountDefault.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.displayDetail',
                                    active: true,
                                }
                            ],
                            permission: 'AccountsDetail',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_LOGIN_HISTORY,
                        path: 'login-history',
                        component: () => import(/* webpackChunkName: "account" */ '../../views/account-next/AccountLoginHistory/AccountLoginHistory.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.loginHistory',
                                    active: true,
                                }
                            ],
                            permission: 'AccountHistoryList',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_HISTORY,
                        path: 'history',
                        component: () => import(/* webpackChunkName: "account" */ '../../views/account-next/AccountHistory/AccountHistory.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.displayHistory',
                                    active: true,
                                }
                            ],
                            permission: 'AccountHistoryList',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_CAPACITY,
                        path: 'capacity',
                        component: () => import('../../views/account-next/AccountCapacity/AccountCapacity.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.capacity',
                                    active: true,
                                }
                            ],
                            permission: 'CapacityDetailAccount',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_COMPANY_REPORT,
                        path: 'report',
                        component: () => import(/* webpackChunkName: "account" */ '../../views/company-next/CompanyReport/CompanyReport.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.company.Report',
                                    active: true,
                                }
                            ],
                            permission: 'AccountInfoReport',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_DEFAULT_SETTING,
                        path: 'default-settings',
                        component: () => import(/* webpackChunkName: "accountSettings" */ '../../views/account-next/AccountDefaultPreferences/AccountDefaultPreferences.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.settings',
                                    active: true,
                                }
                            ],
                            permission: 'AccountDefaultPreference',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_SETTING,
                        path: 'settings',
                        component: () => import(/* webpackChunkName: "accountSettings" */ '../../views/account-next/AccountSettings/AccountSettings.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.settings',
                                    active: true,
                                }
                            ],
                            permission: 'AccountDefaultPreference',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_SYSTEM_LIMIT,
                        path: 'system-limit',
                        component: () => import(/* webpackChunkName: "accountSystemLimit" */ '../../views/account-next/AccountSystemLimit/AccountSystemLimit.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.settings',
                                    active: true,
                                }
                            ],
                            permission: 'AccountSystemLimit',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_SUBSCRIPTIONS,
                        path: 'subscriptions',
                        component: () => import(/* webpackChunkName: "accountSubscriptions" */ '../../views/account-next/AccountSubscriptions/AccountSubscriptions.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.settings',
                                    active: true,
                                }
                            ],
                            permission: 'AccountSubscriptions',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_PRODUCT,
                        path: 'product',
                        component: () => import(/* webpackChunkName: "accountProduct" */ '../../views/account-next/AccountProduct/AccountProduct.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.product',
                                    active: true,
                                }
                            ],
                            permission: 'AccountProduct',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_CREDITS,
                        path: 'credits',
                        component: () => import(/* webpackChunkName: "accountCredits" */ '../../views/account-next/AccountCredits/AccountCredits.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.account.account',
                                    to: { name: E_ROUTE_ACCOUNT.ACCOUNTS },
                                },
                                {
                                    text: 'backoffice.account.productCredits',
                                    active: true,
                                }
                            ],
                            permission: 'AccountCredits',
                        },
                    },
                    {
                        name: E_ROUTE_ACCOUNT.ACCOUNT_DATA_ANALYSIS,
                        path: 'data-analysis/:tab',
                        component: () => import(/* webpackChunkName: "accountDataAnalysis" */ '../../views/account-next/AccountDataAnalysis/AccountDataAnalysis.vue'),
                        props: true,
                        meta: {
                            permission: 'AccountDataAnalysis',
                        },
                    }
                ],
            }
        ],
    }
];
